import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Rust = () => {
  return (
    <StartInterviewLayout type="rust"/>
  )
}

export default Rust;